import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions.web';
import { IconAI } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { close as closeCustomPanel, open as openCustomPanel } from '../../actions.web';
import { getCustomPanelOpen } from '../../functions.web';
/**
 * Implementation of a button for toggling the custom panel.
 */
class CustomPanelButton extends AbstractButton {
    accessibilityLabel = 'toolbar.aiAssist';
    icon = IconAI;
    label = 'toolbar.aiAssist';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeCustomPanel';
    toggledTooltip = 'toolbar.closeCustomPanel';
    tooltip = 'toolbar.aiAssist';
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean} True if the button is toggled, false otherwise.
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Handles clicking the button and toggles the custom panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _isOpen } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        if (_isOpen) {
            dispatch(closeCustomPanel());
        }
        else {
            dispatch(openCustomPanel());
        }
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {Object} The props derived from state.
 */
function mapStateToProps(state) {
    return {
        _isOpen: getCustomPanelOpen(state)
    };
}
export default translate(connect(mapStateToProps)(CustomPanelButton));
